<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="page-content">
        <div class="layout">
          <app-back-button overrideUrl="/app/home"></app-back-button>
          <div class="page-header">
            <h1 class="page-title">Account</h1>
            <p class="subtitle">Manage your profile, premium status, and connections.</p>
          </div>

          <div class="glass-card account-card" *ngIf="user">
            <div class="summary">
              <div class="identity">
                <div>
                  <div class="eyebrow">Tubify Account</div>
                  <div class="value">{{ user.email }}</div>
                </div>
                <ion-button class="secondary-futuristic logout-button" color="medium" (click)="logout()">
                  <ion-icon slot="start" name="power-outline"></ion-icon>
                  <span class="secondary-label">Logout</span>
                </ion-button>
              </div>
              <app-theme-toggle [iconOnly]="true"></app-theme-toggle>
            </div>

            <div class="plan-row glass-card">
              <div>
                <div class="label">Plan</div>
                <div class="pill" [class.premium]="user.isPremium">{{ user.isPremium ? 'Premium' : 'Free' }}</div>
              </div>
              <div class="plan-action">
                <ion-button
                  class="futuristic-button"
                  (click)="togglePremium()"
                  [disabled]="!user?.isPremium || loadingPremium"
                  [attr.aria-describedby]="!user?.isPremium ? 'premium-tooltip' : null"
                >
                  <span [class.upgrade-emphasis]="!user.isPremium">
                    {{ user.isPremium ? 'Downgrade to Free' : 'Upgrade to Premium' }}
                  </span>
                </ion-button>
                <div *ngIf="!user?.isPremium" id="premium-tooltip" class="premium-tooltip">
                  Premium features are not available yet.
                </div>
              </div>
            </div>

            <div class="section-title">Connections</div>
            <div class="connections">
              <div class="conn glass-card" [class.connected]="user.spotifyConnected">
                <div>
                  <div class="conn-name">Spotify</div>
                  <div class="conn-status" [class.active]="user.spotifyConnected">
                    <span class="led" [class.on]="user.spotifyConnected"></span>
                    <span class="status-text">{{ user.spotifyConnected ? 'Linked' : 'Not linked' }}</span>
                  </div>
                </div>
                <div class="conn-actions">
                  <ion-button size="small" (click)="connectSpotify()" fill="clear">
                    <span class="secondary-label">{{ user.spotifyConnected ? 'Reconnect' : 'Connect' }}</span>
                  </ion-button>
                  <ion-button
                    *ngIf="user.spotifyConnected"
                    size="small"
                    fill="clear"
                    color="medium"
                    class="disconnect-btn"
                    (click)="disconnectSpotify()"
                    [disabled]="disconnecting.spotify"
                  >
                    Disconnect
                  </ion-button>
                </div>
              </div>
              <div class="conn glass-card" [class.connected]="user.youtubeConnected">
                <div>
                  <div class="conn-name">YouTube</div>
                  <div class="conn-status" [class.active]="user.youtubeConnected">
                    <span class="led" [class.on]="user.youtubeConnected"></span>
                    <span class="status-text">{{ user.youtubeConnected ? 'Linked' : 'Not linked' }}</span>
                  </div>
                </div>
                <div class="conn-actions">
                  <ion-button size="small" (click)="connectYoutube()" fill="clear">
                    <span class="secondary-label">{{ user.youtubeConnected ? 'Reconnect' : 'Connect' }}</span>
                  </ion-button>
                  <ion-button
                    *ngIf="user.youtubeConnected"
                    size="small"
                    fill="clear"
                    color="medium"
                    class="disconnect-btn"
                    (click)="disconnectYoutube()"
                    [disabled]="disconnecting.youtube"
                  >
                    Disconnect
                  </ion-button>
                </div>
              </div>
            </div>

            <div class="revoke-links" *ngIf="revokeLinks.spotify || revokeLinks.youtube">
              <div class="revoke" *ngIf="revokeLinks.spotify">
                Manage Spotify access:
                <a [href]="revokeLinks.spotify" target="_blank" rel="noopener">Open revoke page</a>
              </div>
              <div class="revoke yt" *ngIf="revokeLinks.youtube">
                Manage YouTube access:
                <a [href]="revokeLinks.youtube" target="_blank" rel="noopener">Open revoke page</a>
              </div>
            </div>

            <div class="section-title">Privacy</div>
            <div class="privacy-card glass-card" routerLink="/settings/cookies">
              <div class="label">Cookie settings</div>
              <ion-icon name="chevron-forward-outline" aria-hidden="true"></ion-icon>
            </div>
            <div class="danger-zone glass-card">
              <button
                type="button"
                class="danger-toggle"
                (click)="toggleDangerZone()"
                [attr.aria-expanded]="dangerOpen"
                aria-controls="danger-content"
              >
                <div class="conn-name danger">Danger zone</div>
                <ion-icon class="chevron" name="chevron-down-outline" aria-hidden="true"></ion-icon>
              </button>

              <div class="danger-content" *ngIf="dangerOpen" id="danger-content">
                <div class="delete-card">
                  <div class="delete-copy">
                    <div class="conn-name danger">Delete account</div>
                    <p class="muted">Removes your account, playlists, and history. This cannot be undone.</p>
                  </div>
                  <ion-button class="delete-button" fill="clear" (click)="confirmDelete()" [disabled]="deleting">
                    Delete account
                  </ion-button>
                </div>
              </div>
            </div>
            <div class="privacy-links">
              <a routerLink="/terms">Terms of use</a>
              <a routerLink="/privacy">Privacy policy</a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
